import { FC } from "react"

import { DividerBlock, PromotionBlock } from "../types/types"

type Props = {
  block: DividerBlock
  onChange: (patch: Partial<PromotionBlock>) => void
}

export const DividerBlockEditor: FC<Props> = ({ block, onChange }) => {
  const props = block.props ?? {}

  return (
    <div className="space-y-2 text-xs opacity-80">
      <p>This is a divider block. It visually separates content.</p>

      <div className="grid grid-cols-4 gap-3">
        <div>
          <label className="block mb-1">Height (px)</label>
          <input
            type="number"
            className="input input-bordered input-sm w-full"
            value={props.height ?? 1}
            onChange={(e) =>
              onChange({
                props: {
                  ...props,
                  height: Number(e.target.value)
                }
              })
            }
          />
        </div>

        <div>
          <label className="block mb-1">Margin (px)</label>
          <input
            type="number"
            className="input input-bordered input-sm w-full"
            value={props.margin ?? 24}
            onChange={(e) =>
              onChange({
                props: {
                  ...props,
                  margin: Number(e.target.value)
                }
              })
            }
          />
        </div>

        <div>
          <label className="block mb-1">Color</label>
          <input
            type="text"
            className="input input-bordered input-sm w-full"
            value={props.color ?? ""}
            onChange={(e) =>
              onChange({
                props: {
                  ...props,
                  color: e.target.value
                }
              })
            }
          />
        </div>

        <div>
          <label className="block mb-1">Variant</label>
          <select
            className="select select-bordered select-sm w-full"
            value={props.variant}
            onChange={(e) =>
              onChange({
                props: {
                  ...props,
                  variant: e.target.value as DividerBlock["props"]["variant"]
                }
              })
            }
          >
            <option value="solid">Solid</option>
            <option value="dotted">Dotted</option>
            <option value="dashed">Dashed</option>
          </select>
        </div>
      </div>

      <div
        className="w-full"
        style={{
          margin: `${props.margin ?? 24}px 0`,
          borderBottom: `${props.height ?? 1}px ${props.variant ?? "solid"} ${props.color ?? "rgba(255,255,255,0.12)"}`
        }}
      ></div>
    </div>
  )
}
